import { Injectable } from '@angular/core';
import { UpdateEveUserStatusGQL, UpdateEveUserStatusMutation, Status } from '../../generated/eveportal-api/graphql';
import { LogService } from './log.service';
import { catchError, Observable, tap, throwError } from 'rxjs';
import { FetchResult } from '@apollo/client/core';

@Injectable({
  providedIn: 'root'
})
export class EveUserStatusService {

  constructor(
    private updateEveUserStatusGQL: UpdateEveUserStatusGQL,
    private logService: LogService
  ) {}

  /**
   * Update the user status and persist to server
   */
  updateUserStatus(eveUserId: number, status: Status): Observable<FetchResult<UpdateEveUserStatusMutation>> {
    
    return this.updateEveUserStatusGQL.mutate({
      eveUserId,
      status
    }).pipe(
      tap((result) => {
        // Log successful update
        this.logService.logInfo(`Successfully updated status to ${status} for user ${eveUserId}`);
      }),
      catchError((error) => {
        const errorMsg = `Failed to update status to ${status} for user ${eveUserId}: ${error.message || error}`;
        this.logService.logError(errorMsg, error);
        return throwError(() => error);
      })
    );
  }
}